import { Formik } from 'formik';
import { Link } from 'react-router-dom';

import AuthForm from './AuthForm';
import AuthInput from './AuthInput';
import AuthSub from './AuthSub';
import AuthSubmit from './AuthSubmit';
import { confirmUserSchema } from './schemas/confirm-user.schema';

import { useConfirmationLink } from '@/hooks/auth/useConfirmationLink';
import { AuthRoutes } from '@/interfaces/auth/AuthRoutes.enum';

type PropTypes = {
	handleSubmit: (username: string, code: string) => Promise<void>;
	loading: boolean;
};
export default function ConfirmUserForm({ handleSubmit, loading }: PropTypes) {
	useConfirmationLink();
	const initialValues = {
		username: '',
		code: '',
	};

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={confirmUserSchema}
			onSubmit={({ username, code }) => handleSubmit(username, code.toString())}
		>
			{({ errors, touched }) => (
				<AuthForm>
					<AuthInput
						name="username"
						label="Username"
						type="email"
						placeholder="Email"
						error={!!errors.username}
						touched={touched.username}
						data-test="confirm-user-username"
					/>
					<AuthInput
						name="code"
						label="Code"
						type="tel"
						placeholder="123456"
						error={!!errors.code}
						touched={touched.code}
						data-test="confirm-user-code"
					/>
					<AuthSubmit
						label="Confirm User"
						isLoading={loading}
						data-test="confirm-user-submit"
						className="bg-purpleBrand-500 hover:bg-purpleBrand-600 active:bg-purpleBrand-900"
					/>
					<AuthSub>
						<p>
							Didn't receive your code?{' '}
							<Link
								className="font-medium text-purpleBrand-500"
								to={AuthRoutes.ResendConfirmationCode}
								data-test="link-resend-confirmation-code"
							>
								Click here
							</Link>
						</p>
						<p>
							Already confirmed?{' '}
							<Link
								className="font-medium text-purpleBrand-500"
								to={AuthRoutes.SignIn}
								data-test="link-sign-in"
							>
								Sign in
							</Link>
						</p>
					</AuthSub>
				</AuthForm>
			)}
		</Formik>
	);
}
